import { StyleSheet } from 'react-native';
import { COLORS, FONTS } from '../../../constants';

export const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 20,
  },
  checkoutContainer: {
    paddingHorizontal: 15,
  },
  countWrapper: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginBottom: 20,
  },
  count: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  countBtn: {
    width: 30,
    height: 30,
    borderWidth: 1,
    borderColor: COLORS.DARKER_GREY,
  },
  countBtnText: {
    color: COLORS.BLACK,
    textAlign: 'center',
    fontSize: 18,
  },
  countText: {
    fontSize: 14,
    paddingHorizontal: 20,
  },
  title: {
    fontFamily: FONTS.AvenirMedium,
    color: COLORS.GREEN,
    fontWeight: '500',
    fontSize: 16,
    letterSpacing: 1,
    marginBottom: 10,
  },
  content: {
    textTransform: 'uppercase',
    fontFamily: FONTS.AvenirMedium,
    color: COLORS.DARKER_GREY,
    fontWeight: '500',
    fontSize: 13,
    letterSpacing: 1,
    textAlign: 'justify',
    marginBottom: 20,
  },
  productRecomentWrapper: {
    borderWidth: 0.5,
    borderColor: COLORS.DARKER_GREY,
    padding: 20,
    marginBottom: 30,
    flexDirection: 'column',
  },
  noteText: {
    fontFamily: FONTS.AvenirMedium,
    color: COLORS.GREEN,
    fontWeight: '500',
    fontSize: 12,
    letterSpacing: 1,
    textTransform: 'uppercase',
  },
});
